import React, { useEffect, useState } from 'react';
import '../css/Bess.css';
import BessImage from '../images/BESS.jpg';
import Bess2 from '../images/BESS2.jpg';
import Bess3 from '../images/BESS3.jpg';
import Bess4 from '../images/BESS4.jpeg';
import Bess5 from '../images/BESS5.jpeg';
import Bess6 from '../images/BESS6.jpg';
import OIP from '../images/OIP.jpg';

function Bess() {
  const [visibleProducts, setVisibleProducts] = useState(4);

  const products = [
    { name: "Product 1", description: "Description 1", img: BessImage },
    { name: "Product 2", description: "Description 2", img: Bess2 },
    { name: "Product 3", description: "Description 3", img: Bess3 },
    { name: "Product 4", description: "Description 4", img: Bess4 },
    { name: "Product 5", description: "Description 5", img: Bess5 },
    { name: "Product 6", description: "Description 6", img: Bess6 },
  ];
  

  const handleShowMore = () => {
    setVisibleProducts((prev) => (prev === 4 ? products.length : 4));
  };

  return (
    <div>
      <section className="head-content">
        <h1>Battery Energy Storage System</h1>
        <p>Revolutionizing energy storage with cutting-edge technology for a sustainable future.</p>
      </section>

      <section className="hero">
        <div className="hero-content">
          <h2>Discover Our Premier Energy Solutions</h2>
          <p>
            Our Battery Energy Storage Systems (BESS) offer reliable, efficient, and scalable energy storage for homes,
            businesses, and utilities.
          </p>
          <button className='btnSolutions'>Explore Our Solutions</button>
        </div>
        <img src={OIP} alt="Battery Storage System" />
      </section>

      <section className="features">
        <h2>Key Features</h2>
        <div className="feature-grid">
          <div className="feature-item">
            <h3>High Efficiency</h3>
            <p>Maximize energy storage and retrieval with top-tier efficiency.</p>
          </div>
          <div className="feature-item">
            <h3>Renewable Integration</h3>
            <p>Seamlessly integrate with solar, wind, and other renewable sources.</p>
          </div>
          <div className="feature-item">
            <h3>Grid Stability</h3>
            <p>Support grid resilience by balancing demand and supply.</p>
          </div>
          <div className="feature-item">
            <h3>Scalable Solutions</h3>
            <p>Customizable for small, medium, and large-scale energy needs.</p>
          </div>
        </div>
      </section>

      <section className="products">
        <h2>Our Solutions</h2>
        <div className="product-grid">
          {products.slice(0, visibleProducts).map((product, index) => (
            <div key={index} className="product-card">
              <img src={product.img} alt={product.name} />
              <h3>{product.name}</h3>
              <p>{product.description}</p>
            </div>
          ))}
        </div>
        <button className='showlessBtn' onClick={handleShowMore}>
          {visibleProducts === 4 ? "Show More" : "Show Less"}
        </button>
      </section>

      <section className="testimonials">
        <h2>What Our Clients Say</h2>
        <div className="testimonial-item">
          <p>
            "The BESS solution transformed how we manage energy at our facility. Highly recommended!"
          </p>
          <span>Rahul Gupta</span>
        </div>
        <div className="testimonial-item">
          <p>
            "Seamless integration with our solar panels. We see significant cost savings."
          </p>
          <span>Vijay Anand</span>
        </div>
      </section>

      <section className="cta">
        <h2>Ready to Embrace the Future of Energy?</h2>
        <button>Contact Us</button>
      </section>
    </div>
  );
}

export default Bess;
